import React, {useEffect} from "react"
import "./BrandArchiveListPage.scss"
import BrandArchiveList from "../components/BrandArchive/BrandArchiveList/BrandArchiveList";
import Header from "../components/Header/Header.component";
import HambergerForHiddenNav from "../components/HambergerForHiddenNav/HambergerForHiddenNav.component";
import {BackwordArrow} from "../../assets/Arrows";
import HomeIcon from "../../img/gnb_home_32.svg";
import {CartWithNumberDt, CartWithNumberMo} from "../../assets/CartWithNumber";
import {AppContext} from "../context/AppContext";
import {useNavigate} from "react-router-dom";
import FooterIncenseVer from "../components/Footer/FooterIncenseVer.component";
import {Helmet} from 'react-helmet';

function BrandArchiveListPage() {
    const {cartDataStore, bannerDataStore} =
        React.useContext(AppContext);
    const navigate = useNavigate()
    const origin = window.location.origin

    useEffect(() => {
        cartDataStore.callCartCount()
        document.querySelector('body').style.backgroundColor = "#ECE0CE"
        return () => {
            document.querySelector('body').style.backgroundColor = "#fffff5"
        }
    }, [])


    return (

        <div className="brand-archive-list-page-wrapper">
            <Helmet>
                <title>콜린스 - Maker&apos;s Note</title>
            </Helmet>
            <Header
                callCartCount={cartDataStore.callCartCount}
                // 사실 아래의 props는 필요 없어짐 -> 진짜 될지 해보자
                // setIsSpinnerShow = {spinnerStore.isSpinnerShow}
                topBannerData={{data: bannerDataStore.topBannerData}}
                topBannerEnabled={
                    bannerDataStore.topBannerData && bannerDataStore.topBannerData.enabled
                }
                isHeaderBgColorChange={true}
                leftContent={
                    <>
                        <HambergerForHiddenNav className="dt"/>
                        <div className="mo">
                            {
                                document.referrer && document.referrer.indexOf(origin) != -1 ? (
                                    <div
                                        style={{cursor: 'pointer'}}
                                        onClick={() => {
                                            history.go(-1);
                                        }}
                                    >
                                        <BackwordArrow/>
                                    </div>
                                ) : (
                                    <div
                                        style={{cursor: 'pointer'}}
                                        onClick={() => {
                                            navigate('/');
                                        }}
                                    >
                                        <img src={HomeIcon} alt=""/>
                                    </div>
                                )}
                        </div>
                    </>
                }
                centerContent={
                    <>
                        <div className="center-text-container mo">Maker&apos;s Note</div>
                        <img
                            src="https://fly.gitt.co/collins/img/logo_b.svg"
                            className="header-logo fixed_logo header-logo-dt dt"
                            style={{
                                pointerEvents: 'all',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                navigate('/')
                            }}
                        />
                    </>
                }
                rightContent={
                    <>
                        <div
                            className=" dt"
                            onClick={() => {
                                navigate('/cart');
                            }}
                        >
                            <CartWithNumberDt number={cartDataStore.cartQuantity}/>
                        </div>
                        <div
                            className="flex  mo"
                            // style ={{display: 'flex'}}
                        >
                            <div
                                className="mo "
                                onClick={() => {
                                    navigate('/cart');
                                }}
                                style={{
                                    marginRight: '10px',
                                }}
                            >
                                <CartWithNumberMo number={cartDataStore.cartQuantity}/>
                            </div>
                            <HambergerForHiddenNav/>
                        </div>
                    </>
                }
            />
            <BrandArchiveList/>
            <FooterIncenseVer/>
        </div>
    )
}

export default BrandArchiveListPage
